export const ITipModalScreenViewModelType = Symbol('ITipModalScreenViewModel');
